import { capitalize, decamelize } from "../commons";
import { isValidUrl } from "../newAppComponent";


const NOTIFICATION_TYPE = {
    ASSESSMENT_PROGRESS: "AssessmentProgress",
    BUILD_PROGRESS: "BuildProgress",
    VULNERABILITY_UPDATE: "VulnerabilityDbUpdated",
    DEPLOYMENT_PROGRESS: "DeploymentProgress"
};



function StatusBadge({ status }) {
    let lowerStatus = `${status}`.toLowerCase();

    return (
        <div className="notification-status-badge"
            style={{
                backgroundColor:
                    (lowerStatus.indexOf("progress") >= 0 || lowerStatus.indexOf("started") >= 0) ?
                        "rgb(65, 83, 175)" :
                        (lowerStatus.indexOf("failed") >= 0 || lowerStatus.indexOf("error") >= 0) ?
                            "rgba(223, 29, 33, 1)" :
                            "rgb(85, 116, 55)"
            }}>
            {capitalize(decamelize(status || ""))}
        </div>
    )
}

function getNotificationStatus(aNotification, appID, accessorString = false) {
    let stringData = aNotification?.notificationData?.message;
    let status = aNotification?.notificationData?.status ? aNotification?.notificationData?.status : "Unknown";
    let outputAdapted = false;
    let outputData = false
    let formattedMessage = "";
    

    if (typeof stringData != "string") {
        stringData = JSON.stringify(aNotification)
    }

    try {
        if (aNotification.notificationType == NOTIFICATION_TYPE.BUILD_PROGRESS) {
            let status = aNotification?.status ? aNotification.status : aNotification.notificationData?.status ? aNotification.notificationData?.status : Object.keys(aNotification.notificationData)[0];

            let msgStr = Object.keys(aNotification?.notificationData?.message || []).map(k => {
                let buildStatus = {
                    message: `${aNotification?.notificationData?.message[k]}`,
                    status: `${k}`
                };
    
                if( buildStatus?.message?.length > 0 ){
                    let outputReg = (/((\s+)?output(\s+)?:(\s+)?Output(\s+)?{)([^]+)/g);
            
                    let outputMatch = outputReg.exec( buildStatus?.message );
            
                    if(outputMatch){
                        buildStatus.message = buildStatus?.message.replace(outputMatch[0], "");
            
                        let stdOut = (/stdout(\s+)?:(\s+)?([^]+)((\s+)?stderr(\s+)?:(\s+)?)/g).exec(outputMatch[6])
                        let stdErr = (/stderr(\s+)?:(\s+)??([^]+)([^\Z]+)/g).exec(outputMatch[6])
                        if( stdOut ){
                            buildStatus.stdout = stdOut[3]
                        }
            
                        if( stdErr ){
                            buildStatus.stderr = stdErr[3]
                        }
                    }
                }

                const rpl = "\\u{1b}[0m\\u{1b}[91m";
                const rpl2 = "\\u{1b}[91m";
                const rpl3 = "\\u{1b}[0m";

                if(typeof buildStatus?.stdout !== 'undefined'){
                    buildStatus.stdout = buildStatus?.stdout.replaceAll(rpl, "\n").replaceAll(rpl2, "\n").replaceAll(rpl3, "\n");
                    buildStatus.stdout = buildStatus?.stdout.replaceAll(`\"\", `,"")


                }   

                if(typeof buildStatus?.stderr !== 'undefined'){

                    buildStatus.stderr = buildStatus?.stderr.replaceAll(rpl, "\n").replaceAll(rpl2, "\n").replaceAll(rpl3, "\n");
                    buildStatus.stderr = buildStatus.stderr.replaceAll(",","\n\n");
                    buildStatus.stderr = buildStatus.stderr.replaceAll("\\r\\n","\n\n");
                    buildStatus.stderr = buildStatus.stderr.replaceAll("\r\n", "\n");
                }
                

                return (
                    <>
                      <div className="notification-bp">
                          <StatusBadge status={buildStatus.status} />
                          <div>{buildStatus.message}</div>
                      </div>
                      {( (typeof buildStatus?.stdout !== 'undefined') && buildStatus?.stdout?.length > 0)&&
                           <>
                            <div className="std_title">STDOUT</div>
                             <div className="std">
                                {buildStatus?.stdout.replaceAll("\\r"," ").split(`\\n`).map((m,i)=>{
                                    return (<div className="stdout" key={"in-"+i}>
                                        {m.replaceAll("\",", "").replaceAll("\"", "")}
                                        <br/>
                                    </div>)
                                })
                                
                                }
                                </div>
                            </>

                         }

                     {(typeof buildStatus?.stderr !== 'undefined')&&
                         <>
                            <div className="std_title error">STDERR</div>
                            <div className="std error">
                            {buildStatus?.stderr.replaceAll("\\r"," ").split(`\\n`).map((m,i)=>{
                                
                                return (<div className="stderr"
                                key={"in-"+i}>
                                    {m.replaceAll("\",", "").replaceAll("\"", "").replaceAll("}", "")}
                                    <br/>
                                </div>)
                            })
                            
                            }
                            </div>
                        </>

                    }
                    
                    </>)
            }
            );




            formattedMessage = <>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "start", alignContent: "top", gap: 1 }}>
                        <StatusBadge status={status} />
                    </div>
                    <div className="mainDetails">
                        {msgStr.map((m, i) => (<div key={`bk-${i}`}>{m}</div>))}
                    </div>

                </div>
            </>
        }
        else if (aNotification.notificationType == NOTIFICATION_TYPE.ASSESSMENT_PROGRESS) {
            let status = aNotification?.status ? aNotification.status : aNotification.notificationData?.status ? aNotification.notificationData?.status : Object.keys(aNotification.notificationData)[0];

            formattedMessage = <>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "start", alignContent: "top", gap: 1 }}>
                        <div
                            className="notification-status-badge"
                            style={{
                                backgroundColor:
                                    status?.toLowerCase().indexOf("progress") >= 0 || status?.toLowerCase().indexOf("started") >= 0 ? "rgb(65, 83, 175)" :
                                        status?.toLowerCase().indexOf("failed") >= 0 ? "rgba(223, 29, 33, 1)" :
                                            "rgb(85, 116, 55)"
                            }}>
                            {capitalize(decamelize(status || ""))}
                        </div>
                    </div>
                    <div className="mainDetails">
                        {aNotification?.notificationData[status] == aNotification?.applicationId ? `Assessment ${status}` : `${aNotification?.notificationData[status]}`}
                    </div>

                </div>
            </>
        } else if (aNotification.notificationType == NOTIFICATION_TYPE.VULNERABILITY_UPDATE) {
            formattedMessage = <>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <StatusBadge status={aNotification?.notificationData?.new_vulnerabilities_count} />
                    <div style={{}}> Vulnerabilities has been added/updated on {getFormattedDate(aNotification?.notificationData?.last_updated_date * 1000)}</div>
                </div>
            </>
        }
        else if (aNotification.notificationType == NOTIFICATION_TYPE.DEPLOYMENT_PROGRESS) {

            let msgStr = `${aNotification?.notificationData?.message}`;

            if (msgStr.indexOf("Adapted wave:") >= 0) {
                try {

                    let mAdapt = (/Adapted wave(\s+)?:(\s+)?at/g).exec(msgStr)
                    if (mAdapt) {

                        let changes = msgStr.split("at path")
                        let output = {}

                        for (let i = 1; i < changes.length; i++) {
                            let vals = changes[i].split("with new value")
                            output[vals[0].replaceAll("'", "").trim()] = vals[1].replaceAll("'", "").trim()
                        }

                        if (output && Object.keys(output)?.length > 0) {
                            outputAdapted = output
                        }
                    }
                } catch (e) {
                    console.log(e)
                }
            }

            let outputsMatch = (/Available outputs(s+)?:([^}]+)/g).exec(msgStr)
            if (outputsMatch) {
                let outputs = outputsMatch[0];

                let outputReg = (/output.(\w+):([^,]+)/g)
                let o = false;
                do {
                    o = outputReg.exec(outputs);
                    if (o) {
                        if (!outputData) {
                            outputData = {}
                        }
                        outputData[o[1].trim()] = o[2].replaceAll("\\", "").replaceAll(`"`, "").trim()
                    }
                } while (o)

                let m2 = (/Available outputs(s+)?:([^}]+)/g).exec(msgStr);
                if (m2) {
                    msgStr = msgStr.replace(m2[0], "")
                }
            }

            let jsFormMessage = msgStr;
            try {
                let startList = ["Rollback for deployment with id ", "Deployment with id "];

                for (let i = 0; i < startList.length; i++) {
                    if (jsFormMessage && jsFormMessage.startsWith(startList[i])) {
                        jsFormMessage = jsFormMessage.replace(startList[i], "");
                        jsFormMessage = startList[i].substring(0, startList[i].indexOf(" ")) + jsFormMessage.substring(jsFormMessage.indexOf(" "), jsFormMessage.length);

                    }
                }

                let match = /ServiceError([^]+)\)/g.exec(jsFormMessage);
                if (match) {
                    let innerMessage = '';

                    let messageMatch = (/message(\s+)?:(\s+)?Some(\s+)?\(\"([^\"]+)\"\)/g).exec(match[0]);
                    if (messageMatch) {
                        innerMessage = messageMatch[4];
                    }

                    jsFormMessage = jsFormMessage.replace(match[0], innerMessage);
                    let actionString = "one or more actions:";
                    let actions = jsFormMessage.indexOf(actionString);

                    if (actions >= 0) {
                        let actionList = jsFormMessage.split(actionString);
                        let actions = actionList[1].split(",");

                        jsFormMessage = [actionList[0] + actionString, ...actions]
                    }
                }

            } catch (e) {
            }

            if (jsFormMessage != msgStr) {
                msgStr = jsFormMessage;
            }

            formattedMessage = <>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <StatusBadge status={status} />
                    <div >
                        {outputAdapted ?
                            <>
                                <div>Adapted wave:</div>
                                {
                                    Object.keys(outputAdapted).sort().map(m => {
                                        return (<div
                                            className="outputEl adapted"
                                            key={`k-${m}`}>
                                            <div className="outputEl_name">{capitalize(decamelize(m))}</div>
                                            <div className={"outputEl_value" + (outputAdapted[m].startsWith("http") && isValidUrl(outputAdapted[m]) ? " link" : "")}
                                                onClick={(e) => {
                                                    if (outputAdapted[m].startsWith("http") && isValidUrl(outputAdapted[m])) {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        window.open(outputAdapted[m])
                                                    }
                                                }}
                                            >{outputAdapted[m]}</div>

                                        </div>)
                                    })
                                }
                                <br />
                            </>
                            :
                            (outputData != false) ?
                                <>
                                    <div>{typeof msgStr == "string" ? msgStr : msgStr.map((m, i) => (<div key={`k-${i}`}>{m}</div>))}</div>
                                    {
                                        Object.keys(outputData).sort().map(m => {
                                            return (<div
                                                className="outputEl"
                                                key={`k-${m}`}>
                                                <div className="outputEl_name">{capitalize(decamelize(m))}</div>
                                                <div className={"outputEl_value" + (outputData[m].startsWith("http") && isValidUrl(outputData[m]) ? " link" : "")}
                                                    onClick={(e) => {
                                                        if (outputData[m].startsWith("http") && isValidUrl(outputData[m])) {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            window.open(outputData[m])
                                                        }
                                                    }}
                                                >{outputData[m]}</div>

                                            </div>)
                                        })
                                    }
                                    <br />
                                </>
                                :
                                <>{typeof msgStr == "string" ? msgStr : msgStr.map((m, i) => (<div key={`k-${i}`}>{m}</div>))}</>
                    }</div>
                </div>
            </>
        } else {
            let jsFormMessage = stringData;
            try {
                let startList = ["Rollback for deployment with id ", "Deployment with id "];

                for (let i = 0; i < startList.length; i++) {
                    if (jsFormMessage && jsFormMessage.startsWith(startList[i])) {
                        jsFormMessage = jsFormMessage.replace(startList[i], "");
                        jsFormMessage = startList[i].substring(0, startList[i].indexOf(" ")) + jsFormMessage.substring(jsFormMessage.indexOf(" "), jsFormMessage.length);

                    }
                }

                let match = /ServiceError([^]+)\)/g.exec(jsFormMessage);
                if (match) {
                    let innerMessage = '';

                    let messageMatch = (/message(\s+)?:(\s+)?Some(\s+)?\(\"([^\"]+)\"\)/g).exec(match[0]);
                    if (messageMatch) {
                        innerMessage = messageMatch[4];
                    }

                    jsFormMessage = jsFormMessage.replace(match[0], innerMessage);
                    let actionString = "one or more actions:";
                    let actions = jsFormMessage.indexOf(actionString);

                    if (actions >= 0) {
                        let actionList = jsFormMessage.split(actionString);
                        let actions = actionList[1].split(",");

                        jsFormMessage = [actionList[0] + actionString, ...actions]
                    }
                }

            } catch (e) { }

            formattedMessage = <>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <StatusBadge status={status} />
                    <div className="mainDetails">
                        {typeof jsFormMessage == "string" ? jsFormMessage : jsFormMessage.map((m, i) => (<div key={`k-${i}`}>{m}</div>))}
                    </div>

                </div>
            </>
        }
    } catch (e) {
        console.log(e)
        formattedMessage = <>
            <div style={{ color: "red" }}>{stringData}</div>
        </>
    }

    return { formatted: formattedMessage, string: stringData, jsonData: aNotification, raw: aNotification };
}

function getCurrentApplication(applications, applicationId) {
    const currentApplication = applications?.find((application) => application.id === applicationId);
    return currentApplication?.name;
}
const options = {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23"
};

function getFormattedDate(date) {
    return new Intl.DateTimeFormat("en-US", options).format(parseInt(date, 10));
}

export {
    getCurrentApplication,
    getFormattedDate,
    getNotificationStatus,
    NOTIFICATION_TYPE
};
